<template>
  <fieldset>
    <legend>
      <span>{{ label }}</span>
    </legend>
    <slot/>
  </fieldset>
</template>

<script>
export default {
  name: "LabeledWrapper",
  props: {
    label: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
fieldset {
    margin: 7px;
    padding: 10px;
    border: 3px solid #c9cccf;
    border-radius: 8px;
}

legend {
    width: auto;
    padding: 0 3px;
    margin: 0;
}

span {
    font-size: 20px;
}


</style>